import type { FulfilmentDto } from "../../../../../core/api/use-get-fulfilments/FulfilmentDto";
import type { FulfilmentsDto } from "../../../../../core/api/use-get-fulfilments/FulfilmentsDto";

export const groupFulfilmentsByDeadline = (
    fulfilmentsDto: FulfilmentsDto,
): { deadline: Date; fulfilments: FulfilmentDto[] }[] => {
    return Object.keys(fulfilmentsDto.fulfilments)
        .map((deadline) => ({
            deadline: new Date(Number(deadline)),
            fulfilments: fulfilmentsDto.fulfilments[
                deadline
            ] as FulfilmentDto[],
        }))
        .sort((a, b) => b.deadline.getTime() - a.deadline.getTime());
};
